import z from "zod";

export const pathEnum = z.enum(["AVS", "RETAIL", "SYSTEM"]);

export const actionTypeEnum = z.enum([
  "CONNECTION",
  "DISCONNECTION",
  "ACCESS_DENIED",
  "KVPS_CHANGE",
  "VEHICLE_SEARCH_INIT",
  "DRAFT_CREATE",
  "DRAFT_UPDATE",
  "DRAFT_DELETE",
  "CTM_VALIDATION",
  "IMPORT_FILE_RCE_CNIT",
  "RCE_CNIT_UPDATE",
  "RCE_CNIT_DELETE",
  "USER_AGREEMENT_CREATE",
  "USER_AGREEMENT_UPDATE",
  "USER_AGREEMENT_DEACTIVATE",
  "USER_AGREEMENT_ACTIVATE",
  "RAPPROCHEMENT_MANUAL",
  "ECOC_IMPORT_RELANCE",
  "ECOC_BATCH_RELANCE",
  "CAR_VIEW_STATUS_CHECK",
  "RAPPROCHEMENT_BATCH",
  "FDM_REQUESTS_IMPORT",
  "FDM_REQUEST_CREATE",
  "FUD_CREATE",
  "BASE_VIN_FORCE_DELETE",
  "BASE_VIN_FILE_IMPORT",
]);

export const resultEnum = z.enum(["OK", "KO_METIER", "KO_TECH"]);

export const getActivityLogListRequestSchema = z.object({
  dateFrom: z.string().optional().nullable(),
  dateTo: z.string().optional().nullable(),
  path: pathEnum.optional().nullable(),
  kvps: z.string().optional().nullable(),
  actionType: actionTypeEnum.optional().nullable(),
  result: resultEnum.optional().nullable(),
  q: z.string().optional().nullable(),
  p: z.coerce.number().int().positive().default(1),
  s: z.coerce.number().int().positive().default(10),
});
